"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ComplianceForContractorWork() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="compliance-for-contractor-work" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`bg-secondary rounded-xl p-8 md:p-12 lg:p-16 shadow-xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-default font-bold text-accent mb-6">
              Will the Labeling Meet Code?
            </h2>
            <p className="text-accent/90 font-default text-base md:text-lg leading-relaxed mb-10">
              Electrical contractor labeling often has to satisfy inspectors and project specs — UL 508A panel marking conventions, NEC 110.16 field marking, NFPA 70E arc flash labeling, and ANSI Z535 safety formatting. Evermark Industrial Solutions produces marking designed to align with these standards when it is properly specified for the installation. Final compliance depends on the equipment, the data on the label, and the authority having jurisdiction, so Evermark recommends confirming requirements with the engineer of record or the inspecting authority. For arc flash labels specifically, Evermark produces the label from the data in your arc flash study and does not perform the study or determine the hazard values.
            </p>
            
          </div>
        </div>
      </div>
    </section>;
}